<template>
  <section class="py-24 bg-white dark:bg-dark relative transition-colors duration-300">
    <div class="container mx-auto px-4">
      <div class="max-w-5xl mx-auto">
        <p class="text-center text-[13px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-600 font-medium mb-10">{{ t('partners.title') }}</p>
        <div class="relative overflow-hidden mb-20">
          <div class="partners-marquee-track">
            <div
              v-for="(client, index) in duplicatedClients"
              :key="`${client.alt}-${index}`"
              class="flex-shrink-0 flex items-center justify-center h-20 w-40 rounded-2xl bg-gray-50 dark:bg-white border border-gray-100 dark:border-transparent overflow-hidden transition-colors duration-300 mx-2.5"
            >
              <img :src="client.src" :alt="client.alt" class="max-h-12 w-auto object-contain px-3" />
            </div>
          </div>
        </div>

        <div class="flex items-center gap-6 mb-20">
          <div class="h-px flex-1 bg-gray-200 dark:bg-white/[0.06] transition-colors duration-300"></div>
          <span class="text-[12px] uppercase tracking-[0.2em] text-gray-400 dark:text-gray-600 font-medium whitespace-nowrap">{{ t('trustedPartners.badge') }}</span>
          <div class="h-px flex-1 bg-gray-200 dark:bg-white/[0.06] transition-colors duration-300"></div>
        </div>

        <div class="flex flex-wrap justify-center items-center gap-5">
          <a v-for="partner in partners" :key="partner.name"
            :href="partner.url" target="_blank" rel="noopener noreferrer"
            class="flex items-center justify-center h-20 w-44 rounded-2xl bg-gray-50 dark:bg-white border border-gray-100 dark:border-transparent overflow-hidden hover:scale-[1.03] transition-all duration-200"
          >
            <img :src="partner.logo" :alt="partner.name" class="max-h-12 w-auto object-contain px-3" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const clients = [
  { src: require('../assets/img/zeth-logo-small.png'), alt: 'ZETH' },
  { src: require('../assets/img/drytech.png'), alt: 'Drytech' },
  { src: require('../assets/img/tisalabs_logo.png'), alt: 'TisaLabs' },
  { src: require('../assets/img/adwater.png'), alt: 'Adwater' },
  { src: require('../assets/img/cagnavin.png'), alt: 'Cagnavin' },
  { src: require('../assets/img/Logo_fernando_curti.jpg'), alt: 'Fernando Curti' },
  { src: 'https://static.wixstatic.com/media/4dead8_3a23ba605dd9409a95fdaaee5020607f~mv2.png/v1/crop/x_281,y_337,w_1439,h_1298/fill/w_274,h_248,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/logo%20senza%20sfondo.png', alt: 'Logo senza sfondo' }
]

const duplicatedClients = [...clients, ...clients]

const partners = [
  { name: 'Digitam', url: 'https://digitam.ch', logo: 'https://digitam.ch/assets/logo-digitam-CDWacl62.png' },
  { name: 'AMWeb', url: 'https://www.amweb.ch', logo: 'https://www.amweb.ch/wp-content/uploads/2017/01/amw_logo_150.png' },
  { name: 'MifaWeb', url: 'https://www.mifaweb.org', logo: 'https://www.mifaweb.org/template/images/mifaweblogo.png' }
]
</script>

<style scoped>
.partners-marquee-track {
  display: flex;
  align-items: center;
  width: max-content;
  animation: partners-scroll 28s linear infinite;
}

@keyframes partners-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
</style>
